import clsx from "clsx";
import { RcFile } from "antd/lib/upload";
import { FaRegEdit } from "react-icons/fa";
import { useEffect, useState } from "react";
import { GrAddCircle } from "react-icons/gr";
import { BiX, BiCheck } from "react-icons/bi";
import { HiOutlineDownload } from "react-icons/hi";
import { IoMdAddCircleOutline } from "react-icons/io";
import { UploadRequestOption } from "rc-upload/lib/interface";
import { BsThreeDotsVertical, BsTrash } from "react-icons/bs";
import {
  AiOutlineSearch,
  AiFillInfoCircle,
  AiOutlineUpload,
  AiOutlineDownload,
  AiOutlineClose,
} from "react-icons/ai";
import {
  Typography,
  Input,
  Row,
  Col,
  Table,
  message,
  Modal,
  Dropdown,
  Card,
  Tooltip,
} from "antd";
import api from "../../services/api";
import { isMobile } from "../../utils";
import { maskCpf } from "../../utils/mask";
import Button from "../../components/Button";
import { useAuth } from "../../contexts/AuthContext";
import { FormModal } from "../../components/FormModal";
import UploadVelotax from "../../components/UploadVelotax";
import { DrawerModal } from "../../components/DrawerModal";
import { permissoes } from "../../constants/others/permissoes";
import { AssessorFormItemRows } from "../../constants/clients";
import { IProfessional, useClients } from "../../contexts/ClientsContext";
import { ReactComponent as EmptyIcon } from "../../assets/icons/empty.svg";
import DeleteConfirmationModal from "../../components/DeleteConfirmationModal";
import {
  SideContent,
  Container,
  Content,
  EmptyContainer,
  ClientContainer,
  ClientPlanContent,
} from "../Clients/styles";

export const assessorTooltip = () => (
  <ul>
    <li style={{ margin: "15px" }}>
      Apenas assessores cadastrados com nível de Gerente ou Administrador
      poderão efetuar a contratação de planos para seus usuários em nome do
      escritório
    </li>
  </ul>
);

var debounce: NodeJS.Timeout;

export const Professionals: React.FC = () => {
  const { user } = useAuth();
  const {
    newClient,
    createClient,
    setNewClient,
    professionals,
    professionalGet,
    getProfessionals,
    totalProfessionals,
    removeProfessional,
    updateProfessional,
    handleDownloadSheet,
  } = useClients();

  const [errors, setErrors] = useState<any>([]);
  const [sendRequest, setSendRequest] = useState(true);
  const [itemRemove, setItemRemove] = useState<any>({});
  const [loadingFile, setLoadingFile] = useState(false);
  const [optionsModal, setOptionsModal] = useState(false);
  const [firstSelected, setFirsSelected] = useState(false);
  const [csvModalVisible, setCsvModalVisible] = useState(false);
  const [errorModalVisible, setErrorModalVisible] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [createModalVisible, setCreateModalVisible] = useState(false);
  const [modalPermissaoVisible, setModalPermissaoVisible] = useState(false);
  const [selectedProfessional, setSelectedProfessional] =
    useState<IProfessional>();

  const dataSource = professionals;
  const hosts = ["-dev", "local"];
  const env = hosts.some((host) => window.location.host.includes(host))
    ? "_dev"
    : "";

  const acesso: any = {
    admin: "Administrador",
    gerente: "Gerente",
    assessor: "Assessor",
  };

  const handleEdit = (item: any) => {
    setCreateModalVisible(!createModalVisible);
    setNewClient(item);
  };

  const beforeUpload = (file: RcFile) => {
    setSendRequest(true);
    if (
      ![
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
        "text/x-csv",
        "text/plain",
        "text/tab-separated-values",
        "text/x-comma-separated-values",
        "text/comma-separated-values",
        "application/x-csv",
        "application/csv",
      ].includes(file.type)
    ) {
      message.error("Envie um arquivo do tipo CSV");
      setSendRequest(false);
    }
  };

  const customRequest = ({ file }: UploadRequestOption) => {
    const formData = new FormData();
    if (!sendRequest) return;
    formData.append("file", file);
    setLoadingFile(true);
    api
      .post("/assessores/batch", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(({ data }) => {
        setLoadingFile(false);
        setCsvModalVisible(!csvModalVisible);
        if (data?.errors?.length === 0) {
          message.success("Integração iniciada com sucesso");
        } else {
          message.error(
            "Erro durante inserção. Favor conferir no modal apresentado."
          );
          setErrors(data.errors);
          setErrorModalVisible(true);
        }
        getProfessionals();
      })
      .catch((error) => {
        setLoadingFile(false);
        message.error(error.response.data.message);
      });
  };

  const setOptionsModalVisibility = () => {
    setOptionsModal(!optionsModal);
    setNewClient(null);
  };

  const setCsvModalVisibility = () => {
    setCsvModalVisible(!csvModalVisible);
    setOptionsModal(!optionsModal);
    setNewClient(null);
  };

  const setDeleteModalVisiblity = () => {
    setDeleteModalVisible(!deleteModalVisible);
  };

  const setCreateModalVisiblity = () => {
    setCreateModalVisible(!csvModalVisible);
    setOptionsModal(!optionsModal);
    setNewClient(null);
  };

  const handleSearch = (value: string) => {
    if (debounce) clearTimeout(debounce);
    debounce = setTimeout(() => {
      getProfessionals(1, value);
    }, 1000);
  };

  const handleRemove = (data: any) => {
    setDeleteModalVisible(!deleteModalVisible);
    setItemRemove(data);
  };

  useEffect(() => {
    getProfessionals();
  }, [getProfessionals]);

  useEffect(() => {
    if (!isMobile() && !firstSelected && professionals?.length > 0) {
      setFirsSelected(true);
      setSelectedProfessional(professionals[0]);
    }
  }, [professionals, firstSelected]);

  return (
    <Container>
      <SideContent>
        <Row gutter={[16, { xs: 12, sm: 10 }]}>
          <Col span={14}>
            <Typography.Title level={1} className="app-title">
              Assessores
            </Typography.Title>
          </Col>
           <Col span={10}>
            <Button
              block
              size="large"
              type="primary"
              icon={<GrAddCircle />}
              onClick={setOptionsModalVisibility}
            >
              Adicionar
            </Button>
          </Col> 
          <Col span={24}>
            <Input
              size="large"
              placeholder="Buscar assessor..."
              prefix={<AiOutlineSearch size={20} />}
              onChange={(e) => handleSearch(e.target.value)}
            />
          </Col>
          <Col span={24} className="ant-col-clients-table">
            <Table
              rowKey="_id"
              dataSource={dataSource}
              loading={professionalGet}
              rowClassName={(item) =>
                item._id === selectedProfessional?._id ? "selected-client" : ""
              }
              pagination={{
                defaultPageSize: 10,
                total: totalProfessionals,
                showLessItems: true,
                showSizeChanger: false,
              }}
              onChange={(pagination) => {
                getProfessionals(pagination.current);
              }}
              columns={[
                {
                  title: (
                    <>
                      <div className="client-table-header professionals">
                        <div className="client-table-header-btns">
                          <Button
                            icon={<HiOutlineDownload />}
                            onClick={() => {
                              if (professionals.length > 0) {
                                handleDownloadSheet("Assessores");
                              }
                            }}
                          />
                        </div>
                      </div>
                    </>
                  ),
                  render: (_, item) => (
                    <Row
                      onClick={() => {
                        setSelectedProfessional(item);
                      }}
                    >
                      <Col span={24}>
                        <Typography.Text className="client-name">
                          {item.name}
                        </Typography.Text>
                      </Col>
                      <Col span={24}>
                        <ClientPlanContent>
                          <Typography.Text className="client-plan">
                            {acesso[item?.acesso]}
                          </Typography.Text>
                        </ClientPlanContent>
                      </Col>
                    </Row>
                  ),
                },
              ]}
            />
          </Col>
        </Row>
      </SideContent>
      <Content
        className={clsx("beauty-scrollbar", {
          "mobile-show": professionals?.length > 0 && selectedProfessional,
        })}
      >
        {professionals?.length === 0 ? (
          <EmptyContainer>
            <EmptyIcon />
            <Typography.Title level={1}>
              Olá, {user.user.name}!
            </Typography.Title>
            <Typography.Paragraph>
              Para iniciar, adicione e selecione clientes na lista ao lado para
              visualizar mais detalhes.
            </Typography.Paragraph>
          </EmptyContainer>
        ) : selectedProfessional ? (
          <ClientContainer>
            <div className="client-actions">
              <Button
                icon={<FaRegEdit />}
                onClick={() => {
                  handleEdit(selectedProfessional);
                }}
              >
                Editar
              </Button>
              <Dropdown
                trigger={["click"]}
                menu={{
                  items: [
                    {
                      key: "remover",
                      label: "Remover",
                      icon: <BsTrash className="icon-card" />,
                      onClick: () => handleRemove(selectedProfessional),
                    },
                  ],
                }}
              >
                <Button
                  icon={<BsThreeDotsVertical />}
                  onClick={(e) => e.preventDefault()}
                />
              </Dropdown>
              <Button
                className="close-client"
                icon={<AiOutlineClose />}
                onClick={() => {
                  setSelectedProfessional(undefined);
                }}
              />
            </div>
            <div className="client-content">
              <Typography.Title level={1}>
                {selectedProfessional.name}
              </Typography.Title>
              <Typography.Paragraph>
                <ClientPlanContent>
                  <Typography.Text className="client-plan professional">
                    {acesso[selectedProfessional?.acesso]}
                    <Tooltip title="Ver permissões detalhadas">
                      <AiFillInfoCircle
                        style={{ cursor: "pointer" }}
                        onClick={() => setModalPermissaoVisible(true)}
                      />
                    </Tooltip>
                  </Typography.Text>
                </ClientPlanContent>
              </Typography.Paragraph>
              <Row gutter={[24, 24]} className="client-info professional">
                <Col>
                  <div className="client-info-title">CPF:</div>
                  <div className="client-info-data">
                    {maskCpf(selectedProfessional.username)}
                  </div>
                </Col>
                <Col>
                  <div className="client-info-title">E-mail:</div>
                  <div className="client-info-data">
                    {selectedProfessional.email}
                  </div>
                </Col>
              </Row>
            </div>
          </ClientContainer>
        ) : (
          <></>
        )}
        <Modal
          footer={null}
          title="Adicione seus assessores"
          visible={optionsModal}
          onCancel={() => setOptionsModal(!optionsModal)}
        >
          <Row gutter={[16, 16]} style={{ marginBottom: "24px" }}>
            <Col>
              <Typography.Paragraph
                style={{ marginBottom: 0, fontWeight: "300" }}
              >
                Escolha a forma que deseja adicionar o assessor:
              </Typography.Paragraph>
            </Col>
            <Col span={isMobile() ? 24 : 12}>
              <Card className="add-card" onClick={setCreateModalVisiblity}>
                <IoMdAddCircleOutline size={30} className="icon-card" />
                <Row className="modal-row">
                  <p>
                    Adicionar assessores <b>manualmente</b>
                  </p>
                </Row>
              </Card>
            </Col>
            <Col span={isMobile() ? 24 : 12}>
              <Card className="add-card" onClick={setCsvModalVisibility}>
                <AiOutlineUpload size={30} className="icon-card" />
                <Row className="modal-row">
                  <p>
                    Importar assessores de <b>planilha Excel</b>
                  </p>
                </Row>
              </Card>
            </Col>
          </Row>
        </Modal>
        <Modal
          footer={null}
          title="Carregue sua planilha"
          visible={csvModalVisible}
          onCancel={() => setCsvModalVisible(false)}
        >
          <Row gutter={[16, 16]}>
            <AiOutlineDownload
              size={20}
              style={{ margin: "4px 5px" }}
              className="icon-card"
            />
            <p
              style={{
                cursor: "pointer",
                margin: "4px 0px",
                fontWeight: "700",
              }}
              onClick={() =>
                window.open(
                  `https://velotax-assets.s3.amazonaws.com/cadastro_assessor_xp${env}.xlsx`
                )
              }
            >
              Baixar planilha modelo
            </p>
            <Col span={24}>
              <UploadVelotax
                accept="all"
                loading={loadingFile}
                beforeUpload={beforeUpload}
                customRequest={customRequest}
              />
            </Col>
          </Row>
        </Modal>
        <DeleteConfirmationModal
          title="Remover profissional"
          body={`Tem certeza que deseja remover ${itemRemove.name} da lista de Assessores ?`}
          visibility={deleteModalVisible}
          onCancel={() => {
            setDeleteModalVisible(false);
          }}
          setVisibility={setDeleteModalVisiblity}
          onOk={() => removeProfessional(itemRemove)}
        />
        <FormModal
          title={newClient ? "Editar profissional" : "Adicionar profissional"}
          itemToEdit={newClient}
          visibility={createModalVisible}
          rows={AssessorFormItemRows(1, newClient)}
          onCancel={() => {
            setCreateModalVisible(false);
          }}
          add={(data: any) => {
            createClient({ ...data, professional: true });
            setCreateModalVisible(false);
            setOptionsModal(false);
          }}
          edit={(data: any) => {
            updateProfessional(data);
            setCreateModalVisible(false);
            setOptionsModal(false);
          }}
        />
        <Modal
          footer={null}
          title="Erro durante o processamento dos seguintes assessores."
          visible={errorModalVisible}
          onCancel={() => setErrorModalVisible(false)}
        >
          <Row gutter={[8, 8]}>
            <Table
              style={{ width: "100%" }}
              rowKey="cpf"
              loading={professionalGet}
              dataSource={errors}
              columns={[
                {
                  title: "Nome, CPF",
                  render: (_, item) => (
                    <>
                      <Row>
                        <Col span={24}>{item.user}</Col>
                      </Row>
                      <Row>
                        <Col span={24}>
                          <p style={{ fontSize: "13px" }}>
                            {maskCpf(item.cpf)}
                          </p>
                        </Col>
                      </Row>
                    </>
                  ),
                },
                {
                  title: "Linha do excel",
                  align: "center",
                  render: (_, item) => (
                    <Row>
                      <Col span={24}>{item.position}</Col>
                    </Row>
                  ),
                },
                {
                  title: "Mensagem",
                  render: (_, item) => (
                    <Row>
                      <Col span={24}>{item.message}</Col>
                    </Row>
                  ),
                },
              ]}
            />
          </Row>
        </Modal>
        <DrawerModal
          width={800}
          footer={null}
          title="Permissões de acesso"
          open={modalPermissaoVisible}
          className="permissoes-acesso-modal"
          onCancel={() => setModalPermissaoVisible(false)}
        >
          <Table
            dataSource={permissoes}
            locale={{
              filterReset: "Limpar",
            }}
            pagination={false}
            columns={[
              {
                title: "",
                render: (_, item) => (
                  <Typography.Text style={{ fontWeight: "500" }}>
                    {item.label}
                  </Typography.Text>
                ),
              },
              {
                title: "Assessor",
                align: "center",
                render: (_, item) =>
                  item.assessor ? (
                    <BiCheck className="check" />
                  ) : (
                    <BiX className="cross" />
                  ),
              },
              {
                title: "Gerente",
                align: "center",
                render: (_, item) =>
                  item.gerente ? (
                    <BiCheck className="check" />
                  ) : (
                    <BiX className="cross" />
                  ),
              },
              {
                title: "Administrador",
                align: "center",
                render: (_, item) =>
                  item.admin ? (
                    <BiCheck className="check" />
                  ) : (
                    <BiX className="cross" />
                  ),
              },
            ]}
          ></Table>
        </DrawerModal>
      </Content>
    </Container>
  );
};
